import { executeRequest } from "@/common/utils/http/httpClient";
import { getCurrentEnvironmentVariables } from "@/lib/CONSTANTS";
import { endpointMapper } from "@/common/service/endpoint.map.js";
import { replaceAllMatchPattern } from "@/common/utils/generic/commonHelper.js";

const envSpecificApiDomain = getCurrentEnvironmentVariables().apiDomain;

const subPath = "v1";
const auditApiPath = `${replaceAllMatchPattern(envSpecificApiDomain[subPath], endpointMapper[subPath].audit)}`;
const myPageApiPath = `${replaceAllMatchPattern(envSpecificApiDomain[subPath], endpointMapper[subPath].myPage)}`;

// ------------------------------------- Audit Service --------------------------------------------------
/**
 * getAuditLogDetails
 * @description: Function which will trigger async call to get respective compliance detail
 *              based on queryParams to trigger this API
 * @returns Array of audit log object
 */

const getAuditLogDetails = async (queryParams, rawResponse = false) => {
  const paramsPath = generateParamsPath(queryParams);
  const url = paramsPath ? `${auditApiPath}/audit?${paramsPath}` : `${auditApiPath}/audit`;
  return executeRequest({
    url,
    method: "GET",
    rawResponse
  });
};

/**
 * getAuditLogCategories
 * @description: Function which will trigger async call to get audit categories for filter
 *               trigger this API
 * @returns Array of category object
 */

const getAuditLogCategories = async (rawResponse = false) => {
  const url = `${auditApiPath}/audit/categories`;
  return executeRequest({
    url,
    method: "GET",
    rawResponse
  });
};

// ------------------------------------- MyPage Service --------------------------------------------------

/**
 * postUserComments
 * @description: Function which will trigger async call to add user comments
 *              based on the complianceId
 * @returns Object
 */
const postUserComments = async (req_body, rawResponse = false) => {
  const url = `${myPageApiPath}/aggregator/userComment`;
  return executeRequest({
    url,
    method: "POST",
    body: JSON.stringify(req_body),
    rawResponse
  });
};

// ------------------------------- Common Function --------------------------------------------

/**
 * generateParamsPath
 * @description: Function which will accept params object and create query params url
 *
 * @returns query params url string
 */
const generateParamsPath = params => {
  if (params) {
    const parts = [];
    for (const [key, value] of Object.entries(params)) {
      if (value != null && value !== "") {
        parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
      }
    }
    return parts.join("&");
  }
};

export { getAuditLogDetails, getAuditLogCategories, postUserComments };
